<template>
  <div class="container">

    <Head v-if="meta.title" v-bind:meta="meta" :key="this.render + 1"></Head>
    <Header></Header>
    <Navigation></Navigation>
    <Breadcrumbs v-if="breadcrumbs" v-bind:breadcrumbs="breadcrumbs"></Breadcrumbs>
    <CollectionsContent v-if="collections"></CollectionsContent>
    <Footer></Footer>
  </div>
</template>

<script>
// libraries
//import Vivus from 'vivus'
import axios from "axios";
import { eventBus } from "@/main.js";
import NProgress from "nprogress";

//import Swiper from 'swiper'

// components

import Head from "@/components/Common/Head.vue";
import Header from "@/components/Header/Header.vue";
import CollectionsContent from "@/components/Collections/CollectionsContent.vue";
import Navigation from "@/components/Common/Navigation.vue";
import Footer from "@/components/Footer/Footer.vue";
import Breadcrumbs from "@/components/Common/Breadcrumbs.vue";

// https://fizykoteka.ckc.uw.edu.pl/omeka/api/items?item_type=FizykotekaBiogram

// call ajax

// functions

export default {
  name: "Collections",
  props: ["apiCall"],
  components: {
    Head,
    Header,
    Navigation,
    CollectionsContent,
    Breadcrumbs,
    Footer,
  },
  data() {
    return {
      results: Array,
      collections: null,
      total_results: Number,
      swiper_style:
        "transition: all 0ms ease 0s; transform: translate3d(0px, 0px, 0px)",
      msg: "Welcome to Your Vue.js App",
      head_title: "Kolekcje",
      component_title: "Kolekcje",
      sort_field: "id",
      sort_dir: "d",
      // dobre
      meta: {
        url: window.location.href,
        description: "",
        title: "Kolekcje",
        og_type: "website",
        og_image: "",
      },
      breadcrumbs: {
        parent_title: "",
        parent_uri: "",
        self_title: "Kolekcje",
        self_uri: window.location.href,
      },
      render: null,
      page: 1,
    };
  },
  methods: {
    fetchData() {
      NProgress.start();
      axios
        .get(
          this.$config.API_PATH +
          this.apiCall +
          "?sort_field=" +
          this.sort_field +
          "&sort_dir=" +
          this.sort_dir +
          "&page=" +
          this.page
        )
        .then((_resp) => {
          this.results = _resp.data;
          this.total_results = _resp.headers["omeka-total-results"];
          let _collections = [];
          let _index = 0;

          this.results.forEach(function (_collection) {
            let _metadata = _collection.element_texts;
            let _title = _metadata.find((x) => x.element.id == "50").text;
            let _image = require("@/assets/img/default.png");
            if (_collection.cover_img) _image = _collection.cover_img;
            _collections.push({
              index: _index,
              id: _collection.id,
              title: _title,
              image: _image,
              count: _collection.items.count,
            });
            _index++;
          });
          this.collections = _collections;
          if (this.total_results > this.collections.length) {
            this.page++;
            this.fetchData();
          }
        })
        .then(() => {
          setTimeout(function () {
            NProgress.done();
          }, 1500);
          this.renderMe();
        });
    },
    renderMe() {
      if ("function" == typeof Swiper && $(".collections-page").length) {
        const mySwiper = new Swiper(".swiper-container", {
          direction: "vertical",
          slidesPerView: "auto",
          observer: true, // https://stackoverflow.com/a/56535456
          watchSlidesVisibility: !0,
          mousewheel: {
            invert: true,
            eventsTarget: '.swiper-container div'
            //forceToAxis: true
          },
          on: {
            slideChangeTransitionStart: function (swiper) {
              var i = swiper.activeIndex;
              swiper.isBeginning
                ? $(".collections-control.go-left").addClass("hidden")
                : $(".collections-control.go-left").removeClass("hidden"),
                swiper.isEnd
                  ? $(".collections-control.go-right").addClass("hidden")
                  : $(".collections-control.go-right").removeClass("hidden"),
                $(".featured-images img").removeClass("shown"),
                $(".featured-images img").eq(i).addClass("shown");
            },
          },
        });

        $(".col-filter-showall a").click((ev) => {
          ev.preventDefault();
          const el = ev.target;
          mySwiper.params.slidesPerView = this.total_results;
          $('.swiper-container').addClass('generic-list');
          $('.arrow-link svg').hide();
          mySwiper.update();
          $(el).css('display', 'none');
        });


        $(".collections-control").click(function () {
          //console.log(mySwiper.activeIndex);
          if ($(this).hasClass("go-left")) {
            mySwiper.slideTo(mySwiper.activeIndex - 4);
          } else {
            mySwiper.slideTo(mySwiper.activeIndex + 4);
          }
          // $(this).hasClass("go-left")
          //   ? mySwiper.slidePrev()
          //   : mySwiper.slideNext();
        });
        $(".collections-page .swiper-slide a").on("mouseover", function (e) {
          e.preventDefault();
          var i = +$(this).attr("data-index");

          $(".featured-images img").removeClass("shown");
          $(".featured-images img").eq(i).addClass("shown");
        });
      }
    },
  },
  destroyed() { },
  mounted: function () {
    //this.renderMe()
    //this.setActions()
    eventBus.$on("sort", (a) => {
      if (a[0] == "id") {
        //id
        this.sort_field = "id";
        this.sort_dir = a[1];
        this.fetchData();
      } else {
        //az
        this.sort_field = "Dublin+Core%2CTitle";
        this.sort_dir = a[1];
        this.fetchData();
      }
    });
  },
  updated: function () {
    //this.renderMe();
  },
  created() {
    this.fetchData();
    this.render = Math.random();
    //this.renderMe();
  },
  watch: {
    $route: "fetchData",
    collestions: function () {
      //this.renderMe();
    },
  },
  head: {
    link: [
      {
        rel: "stylesheet",
        href: "//unpkg.com/swiper/swiper-bundle.min.css",
      },
      {
        rel: "stylesheet",
        href: "//cdn.jsdelivr.net/npm/simplebar@latest/dist/simplebar.css",
      },
    ],
  },
};
</script>

<style>
.generic-list {
  height: 100% !important;
  min-height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/components/Collections/Collections.vue